import React, { useEffect, useState } from "react";
import ProfileContactsElement from "../../../../Pages/ProfileUser/Contacts/ContactsContainer/ProfileContactsElement.js";
import Pagination from "../../../../Reusable/Pagination/Pagination.js";
import config from "config";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import { ContactElementModal } from "./ContactElementModal/index.tsx";
import Button from "components/Elements/Button/Button.js";
import SearchContact from "./SearchContact.js";
import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "contexts/modalContext/modalContext.js";
import {
  ReactGetInboxContacts,
  CreateUserContact,
  exportContactsListToCsv,
  exportExampleContactsListToCsv,
  deleteSelectedContactsApi,
  exportContactsListToExcel,
} from "../../../../Pages/Inbox/Contacts/ApiContactCalles.js";
import { useRateLimitError } from "hooks/useRateLimitError.ts";

const ContactListWrapper = ({
  contactList,
  listView,
  setContactList,
  setContactsQuantity,
  setCurrentPage,
  currentPage,
  setReloadContactList,
  handleSubmit,
  countFavoritesUsers,
  selectAllContacts,
  setSelectAllContacts,
  setSelectedContactList,
  selectedContactList,
  deleteSelectedContacts,
  loadingDeleteContacts,
}) => {
  const { getTextByKey } = useContent();
  return (
    <div className="contacts-container">
      <div className="select-contacts-container">
        <CheckboxElement
          state={selectAllContacts}
          setState={setSelectAllContacts}
        />
        <button
          disabled={!selectedContactList.length}
          className="delete-action-container"
          onClick={() => deleteSelectedContacts()}
        >
          <span className="action-delete-text">
            {getTextByKey("delete-selected-contacts")}
          </span>
          <span className="count-selected">
            {" "}
            {`(${selectedContactList.length} ${getTextByKey(
              "contacts-selected"
            )})`}
          </span>
        </button>
        <div
          className={`loading-contacts-container ${
            loadingDeleteContacts ? "" : "hide-loading"
          }`}
        >
          <LoadingImageElement />
        </div>
      </div>
      {contactList &&
        contactList.map((item, i) => {
          return (
            <ProfileContactsElement
              details={item}
              listView={listView}
              key={i}
              index={i}
              contactList={contactList}
              setContactList={setContactList}
              setContactsQuantity={setContactsQuantity}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              setReloadContactList={setReloadContactList}
              handleSubmit={handleSubmit}
              countFavoritesUsers={countFavoritesUsers}
              selectAllContacts={selectAllContacts}
              setSelectedContactList={setSelectedContactList}
              loadingDeleteContacts={loadingDeleteContacts}
              selectedContactList={selectedContactList}
            />
          );
        })}
    </div>
  );
};

const ContactsContainer = ({ listView, children, onContactAdded }) => {
  const { getTextByKey, getLanguage } = useContent();
  const { setModal, closeModal } = useModal();

  const { getUserData } = useUser();
  const userData = getUserData();
  const [contactList, setContactList] = useState([]);
  const [contactsQuantity, setContactsQuantity] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reloadContactList, setReloadContactList] = useState(false);
  const [excelFileValue, setExcelFileValue] = useState("");
  const { addToast } = useToasts();
  const [existMails, setExistMails] = useState([]);
  const [successImports, setSuccessImports] = useState([]);
  const [invalidMails, setInvalidMails] = useState([]);
  const [displayImportModal, setdisplayImportModal] = useState(false);
  const [countFavoritesUsers, setCountFavoritesUsers] = useState(false);
  const [selectAllContacts, setSelectAllContacts] = useState(false);
  const [selectedContactList, setSelectedContactList] = useState([]);
  const [loadingDeleteContacts, setLoadingDeleteContacts] = useState(false);
  const { isRateLimitError, showRateLimitError } = useRateLimitError();
  useEffect(() => {
    if (contactList) {
      //count favorites users
      let favoritesUsers = contactList.filter(
        (item) => item.contact_list_favorite
      );
      if (favoritesUsers !== null) {
        setCountFavoritesUsers(favoritesUsers.length);
      }
    }
  }, [contactList]);

  const handleSubmit = (body) => {
    return CreateUserContact({
      formBody: body,
      setContactList,
      setContactsQuantity,
      setCurrentPage,
    }).then((res) => {
      if (res.status === "success") {
        addToast(getTextByKey("success-add-contact"), {
          appearance: "success",
        });
        onContactAdded && onContactAdded();
        closeModal();
        return res;
      } else {
        if (isRateLimitError(res)) return showRateLimitError();
        addToast(getTextByKey(res.data), {
          appearance: "error",
        });
        return res;
      }
    });
  };

  useEffect(() => {
    if (userData) {
      ReactGetInboxContacts({
        currentPage: currentPage,
        setContactList: setContactList,
        setContactsQuantity: setContactsQuantity,
      });
    }
  }, [userData, currentPage]);

  useEffect(() => {
    if (reloadContactList) {
      setCurrentPage(1);
      ReactGetInboxContacts({
        currentPage: 1,
        setContactList: setContactList,
        setContactsQuantity: setContactsQuantity,
      });
      setReloadContactList(false);
    }
  }, [reloadContactList]);

  //upper the num of pages
  function up(v, n) {
    return Math.ceil(v * Math.pow(10, n)) / Math.pow(10, n);
  }

  const exportContactsToExcel = async () => {
    await exportContactsListToExcel({ culture: getLanguage() });
  };

  const exportContcatsToCsv = () => {
    //ExportContactsListToCsv
    exportContactsListToCsv({
      culture: getLanguage(),
    });
  };

  const exportExampleFileContactsToCsv = () => {
    exportExampleContactsListToCsv({ culture: getLanguage() });
  };

  const handleChangeInputFile = (file) => {
    let excelFile = file[0];
    const formData = new FormData();
    formData.append("file", excelFile);
    importExcelFileToContacts(
      userData.UserId,
      getLanguage(),
      formData,
      excelFile
    );
  };

  const importExcelFileToContacts = async (
    userId,
    culture,
    formData,
    excelFile
  ) => {
    const response = await apiRequest(
      "ContactsLists",
      `ImportContactsList?userId=${userId}&culture=${culture}&FileName=${excelFile.name}`,
      formData,
      "POST",
      null,
      null,
      null,
      true
    );
    if (response.status === "success") {
      if (response.data) {
        let displayMessage = false;
        let displayError = false;
        const hasSuccess =
          response.data.ContactsList && response.data.ContactsList.length > 0;
        const hasInvalid =
          response.data.InvalidMails && response.data.InvalidMails.length > 0;
        const hasExist =
          response.data.MailsExist && response.data.MailsExist.length > 0;

        if (hasExist) {
          setExistMails(response.data.MailsExist);
          displayMessage = true;
        } else {
          setExistMails([]);
        }
        if (hasInvalid) {
          setInvalidMails(response.data.InvalidMails);
          displayMessage = true;
        } else {
          setInvalidMails([]);
        }
        if (hasSuccess) {
          setSuccessImports(response.data.ContactsList);
          addToast(
            response.data.ContactsList.length +
              " " +
              getTextByKey("success-mails-imported"),
            {
              appearance: "success",
            }
          );
          setReloadContactList(true);
        } else {
          setSuccessImports([]); // Clear previous successes if none this time
          if (displayMessage) {
            setReloadContactList(true);
          }
        }
        displayError = !hasSuccess && !displayMessage;
        if (displayError) {
          addToast(getTextByKey("error-import-csv"), {
            appearance: "error",
          });
        }
        setdisplayImportModal(displayMessage);
      } else {
        addToast(getTextByKey("error-import-csv"), {
          appearance: "error",
        });
      }
      //clear the input file
    } else {
      addToast(getTextByKey("error-import-csv"), {
        appearance: "error",
      });
    }
    setExcelFileValue("");
  };

  useEffect(() => {
    if (displayImportModal) {
      setModal({
        modal: ImportModal,
        modalSize: "full-modal",
      });

      setdisplayImportModal(false);
    }
  }, [displayImportModal]);

  const ImportModal = () => {
    return (
      <div className="import-contacts-modal-container">
        <div className="success-mails">
          {successImports && successImports.length > 0 && (
            <div className="success-counts-mails">
              {successImports.length} {getTextByKey("success-mails-imported")}
            </div>
          )}
        </div>
        <div className="exist-mails">
          {existMails && existMails.length > 0 && (
            <div className="exist-counts-mails">
              <div className="exist-title">
                <h3>{getTextByKey("exist-mails-title")}</h3>
              </div>
              <div className="failed-list">
                {" "}
                {existMails.map((item, i) => (
                  <div className="failed-mail" key={i}>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="exist-mails">
          {invalidMails && invalidMails.length > 0 && (
            <div className="exist-counts-mails">
              <div className="exist-title">
                <h3>{getTextByKey("invalid-mails-title")}</h3>
              </div>
              <div className="failed-list">
                {" "}
                {invalidMails.map((item, i) => (
                  <div className="failed-mail" key={i}>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const addContact = () => {
    setModal({
      modal: ContactElementModal,
      modalSize: "full-modal",
      props: {
        isEdit: false,
        countFavoritesUsers,
        handleSubmit: handleSubmit,
      },
    });
  };

  const deleteSelectedContacts = async () => {
    if (selectedContactList && selectedContactList.length > 0) {
      const res = await deleteSelectedContactsApi({
        selectedContactList: selectedContactList,
        setReloadContactList: setReloadContactList,
        setLoadingDeleteContacts: setLoadingDeleteContacts,
        setSelectedContactList: setSelectedContactList,
        setSelectAllContacts: setSelectAllContacts,
      });
      if (res.status === "success") {
        addToast(getTextByKey("contact-remove-success"), {
          appearance: "success",
        });
      }
    }
  };

  return (
    <div className="contacts-wrapper">
      <div className="contact-title">
        <div className="contact-title-div">
          <h3>{getTextByKey("profile-menu-contacts-list")}</h3>
        </div>
        <div className="right-side">
          <div className="exports-div">
            <div className="exports">
              <h3>{getTextByKey("export")}:</h3>
              <div className="exports-container">
                <div
                  className="export-to-excel"
                  onClick={() => exportContactsToExcel()}
                >
                  <span className="text-span">excel</span>
                </div>
                <div
                  className="export-csv"
                  onClick={() => exportContcatsToCsv()}
                >
                  <span className="text-span">csv</span>
                </div>
              </div>
            </div>
            <div className="import-excel">
              <h3>{getTextByKey("import")}:</h3>
              <div className="import-container">
                <div className="import-csv">
                  <label className="text-span" htmlFor="upload-file">
                    csv
                  </label>
                  <input
                    accept=".csv"
                    value={excelFileValue}
                    onChange={(e) => handleChangeInputFile(e.target.files)}
                    type="file"
                    name="photo"
                    id="upload-file"
                  />
                </div>
              </div>
            </div>
            <div className="example-excel">
              <h3>{getTextByKey("contacts-file-example")}:</h3>
              <div className="import-container">
                <div className="import-csv">
                  <Tooltip
                    id={"csv-demo-tooltip"}
                    tooltipTextKey="csv-demo-tooltip"
                    top
                  >
                    <label
                      className="text-span"
                      onClick={() => exportExampleFileContactsToCsv()}
                    >
                      {getTextByKey("csv-demo")}
                    </label>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <div className="add-contact">
            <Button className="new-button" onClick={addContact}>
              {getTextByKey("add-contact")}
            </Button>
          </div>
        </div>
      </div>
      <SearchContact
        contactList={contactList}
        setContactList={setContactList}
        countFavoritesUsers={countFavoritesUsers}
      />

      {/* <Form
        fieldsProps={{ label: "hidden", field: "square" }}
        fields={contactsFields}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("add-contact"),
          className: "add-contact-submit-button",
        }}
        buttonProps={{ buttonsSize: "large" }}
      /> */}
      <ContactListWrapper
        contactList={contactList}
        listView={listView}
        setContactList={setContactList}
        setContactsQuantity={setContactsQuantity}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        setReloadContactList={setReloadContactList}
        handleSubmit={handleSubmit}
        countFavoritesUsers={countFavoritesUsers}
        selectAllContacts={selectAllContacts}
        setSelectAllContacts={setSelectAllContacts}
        setSelectedContactList={setSelectedContactList}
        selectedContactList={selectedContactList}
        deleteSelectedContacts={deleteSelectedContacts}
        loadingDeleteContacts={loadingDeleteContacts}
      />
      {contactList && contactsQuantity > 10 && (
        <Pagination
          maxPages={contactsQuantity > 0 ? up(contactsQuantity / 10, 0) : 1}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default ContactsContainer;
